<template>
  <ui-serp :filter-category="filterCategory" :path="path" :results="results" :loading="loading" :selected-category="selectedCategory"/>
</template>
<script setup lang="ts">

import categories from "assets/models/causes.json";
import type {ONPRecord} from "~/types/record";
const route = useRoute()
const path = ref('cause-sociali');
const filterCategory = ref('causes');
// Cambia style di navbar per questa pagina
const navbarType = inject('navbarType')
navbarType.value = 'light';

// Categoria selezionata
const selectedCategory = ref();
selectedCategory.value = categories.find(a => a.slug === route.params.slug);
const {getOnpListFromKey} = useRecords();
const results: Ref<ONPRecord[]> = ref([]);
const loading = ref(true);
const loadData = async (value) => {
  results.value = await getOnpListFromKey(filterCategory.value, value);
  loading.value = false;
}

import { useMediaQuery } from '@vueuse/core'
const isLargeScreen = useMediaQuery('(min-width: 1024px)')
useSeoMeta({
  title: isLargeScreen.value ? selectedCategory.value?.navbarTitle : selectedCategory.value?.label,
  description: selectedCategory.value?.description,
})

onMounted(() => {
  // questa funzione monitora il cambio di route e aggiorna il child attivo
  watch(() => route.params, async (val) => {
    // se c'è uno slug nel path allora applico il filtro relativo
    if(selectedCategory.value) await loadData(selectedCategory.value.label);
  }, {deep: true, immediate: true});
})

</script>